import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/studio/animation/animationCard.css";
import { formatDate } from "../../utils/date";
import { truncateText } from "../../utils/text";
import { deleteAnimation } from "../../services/animation.service";
import PricingSection from "./PricingSection";

const MAX_TITLE = 50;
const MAX_DESC = 100;

const AnimationCard = ({ data, onDelete }) => {
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);
  const [showPricing, setShowPricing] = useState(false);
  const [pricing, setPricing] = useState({
    accessType: data?.accessType || "free",
    price: data?.price || 0,
    currency: data?.currency || "USD",
    pricingModel: data?.pricingModel || "lifetime",
  });

  if (!data) return <div className="animation-card" />;

  const handleOpen = () => {
    navigate(`/studio/animations/${data.animationId}`);
  };

  const handleDelete = async () => {
    if (!confirm(`Delete "${data.title}"? This cannot be undone.`)) return;
    setDeleting(true);
    try {
      await deleteAnimation(data.animationId);
      onDelete?.(data.animationId);
    } catch (err) {
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="animation-card">
      <div className="animation-card-header">
        <h3 className="animation-card-title">
          {truncateText(data.title, MAX_TITLE)}
        </h3>
      </div>

      <p className="animation-card-description">
        {truncateText(data.description, MAX_DESC) || "No description"}
      </p>

      <div className="animation-card-meta">
        <span>Duration: {data.duration || 0}s</span>
        <span>Updated: {formatDate(data.updatedAt)}</span>
      </div>

      <div className="animation-card-actions">
        <button onClick={handleOpen}>Open in Editor</button>
        <button onClick={() => setShowPricing((p) => !p)}>
          {showPricing ? "Hide Pricing" : "Pricing"}
        </button>
        <button onClick={handleDelete} disabled={deleting} className="danger-btn">
          {deleting ? "Deleting..." : "Delete"}
        </button>
      </div>

      {showPricing && (
        <PricingSection
          contentType="animation"
          contentId={data.animationId}
          pricing={pricing}
          setPricing={setPricing}
        />
      )}
    </div>
  );
};

export default AnimationCard;
